import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

class MagazineFilter extends React.Component {
    static propTypes = {
        data: PropTypes.number
    };

    static defaultProps = {
        data: 2006
    };

    state = {
        dates: [],
        date: 0,
        dropdownMenuClass: "",
        dropdownArrow: "down",
        dropdownItemClass: "hide"
    };

    handleInputChange = (e) => {
        // this.setState({date: e.target.value});
        if(e.target.textContent === "All") {
            window.location = "/magazine";
        } else {
            window.location = "/magazine/"+e.target.textContent;
        }
    }

    setInitialState = (date, dates) => {
        this.setState({date});
        this.setState({dates});
    }

    componentDidMount() {
        let location = window.location.pathname;

        let test = location.split("/magazine/");

        let date = "All";

        if(test.length > 1){
            date = test[1].replace(/\//, "");
        }

        let dates = ["All"];

        let year = dayjs.tz(new Date(), "America/New_York").year();

        for(let i = year; i >= this.props.data; i--){
            dates.push(i);
        }

        this.setInitialState(date, dates);
    }

    componentWillUnmount() {
        this.setInitialState = () => {};
    }

    dropdownToggle = () => {
        if(this.state.dropdownMenuClass !== "open"){
            //Expand container before fading in dropdown items
            this.setState({
                dropdownMenuClass: "open",
                dropdownArrow: "up",
            });

            setTimeout( () => {
                this.setState({
                    dropdownItemClass: "show-items"
                });
            }, 150);
        } else{
            //Collapse everything at once
            this.setState({
                dropdownItemClass: "",
                dropdownMenuClass: "",
                dropdownArrow: "down"
            });
        }
    }

    render() {
        return (
            <div className="MagazineFilter">
                <div className="filter-container" onClick={this.dropdownToggle}>
                    <h5>{this.state.date}
                        <span>{this.state.dropdownArrow == "up" ? <i className="fas fa-arrow-up dropdown-arrow" /> : <i className="fas fa-arrow-down dropdown-arrow" />}</span>
                    </h5>
                    <div className={`dropdown-menu ${this.state.dropdownMenuClass}`}>
                        {this.state.dates.map((item) => {
                            if(this.state.date !== item){
                                return (
                                    <h5 className={`dropdown-item ${this.state.dropdownItemClass}`} onClick={this.handleInputChange} key={item}>{item}</h5>
                                );
                            }
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default MagazineFilter;
